import { render, staticRenderFns } from "./ScheduleSetup.vue?vue&type=template&id=5127af44&scoped=true"
import script from "./ScheduleSetup.vue?vue&type=script&lang=ts"
export * from "./ScheduleSetup.vue?vue&type=script&lang=ts"
import style0 from "./ScheduleSetup.vue?vue&type=style&index=0&id=5127af44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5127af44",
  null
  
)

export default component.exports